import React from 'react'
import BreadCrumbs from '../breadcrumbs/BreadCrumbs'
import { TertiaryButtonDark } from '../unilink/index'
import SubjectToCSSName from '../../less/SubjectToCSSName'
import isEqual from 'lodash/isEqual'
import './leafTopicCard.css'

const TITLE_LENGTH = 50
class LeafTopicCard extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (isEqual(nextProps.style, this.props.style)) {
      return false
    } else {
      return true
    }
  }

  render() {
    const { topic, topAncestor, className, style } = this.props
    const breadcrumbTopics = [topic.parent]
    //const description = topic.renderedDescription
    const titleIsLong = topic.renderedTitle.length > TITLE_LENGTH

    const classNames = ['leaftopic-card', className]
    return (
      <div style={style} className={classNames.join(' ')}>
        <div
          className={`leaftopic-card__body leaftopic-card__body--${
            SubjectToCSSName[topAncestor.id]
          }`}
        >
          <BreadCrumbs
            className="leaftopic-card__breadcrumbs"
            breadcrumbTopics={breadcrumbTopics}
          />
          <h2
            className="leaftopic-card__title"
            style={
              titleIsLong
                ? {
                  fontSize: '.875rem'
                }
                : null
            }
            dangerouslySetInnerHTML={{ __html: topic.renderedTitle }}
          />
          <TertiaryButtonDark
            to={topic.slug}
            className={`leaftopic-card__button leaftopic-card__button--${
              SubjectToCSSName[topAncestor.id]
            }`}
          >
            {' '}
            Start{' '}
          </TertiaryButtonDark>
          {
            // <span
            //   className="leaftopic-card__description"
            //   dangerouslySetInnerHTML={{ __html: description }}
            // />
          }
        </div>
        {
          // <div className="leaftopic-card__foot">
          //   <div className="leaftopic-card__explanation-counts" />
          // </div>
        }
      </div>
    )
  }
}

export default LeafTopicCard



// WEBPACK FOOTER //
// ./src/core/components/leaf-topic-card/LeafTopicCard.js